import { dinheiroExtenso, esc } from './util';

/**
 * Campo de dinheiro: "R$" + número com separador de milhar, valor por extenso embaixo e botões de ajuste rápido.
 * O texto digitado vira número em main.ts (evento `input` com data-money); os botões usam a ação `din-ajuste`.
 */

export type CampoDinheiro = 'leilao-preco' | 'leilao-valor' | 'oferta';

export interface BotaoDinheiro {
  rotulo: string;
  /** número (soma ao valor atual), 'min' (vai ao mínimo) ou 'ref' (vai ao valor de referência) */
  delta: number | 'min' | 'ref';
}

export function formatarNumero(n: number): string {
  return n > 0 ? Math.round(n).toLocaleString('pt-BR') : '';
}

export function chaveDinheiro(campo: CampoDinheiro, id?: number): string {
  return id === undefined ? campo : `${campo}:${id}`;
}

export function campoDinheiro(
  campo: CampoDinheiro,
  valor: number,
  opcoes: { id?: number; min: number; ref?: number; botoes: BotaoDinheiro[]; rotulo?: string },
): string {
  const chave = chaveDinheiro(campo, opcoes.id);
  const atributos = `data-money="${campo}" ${opcoes.id !== undefined ? `data-id="${opcoes.id}"` : ''} data-min="${opcoes.min}"`;
  const botoes = opcoes.botoes
    .map(
      (b) =>
        `<button type="button" class="chip" data-a="din-ajuste" data-campo="${campo}" ${opcoes.id !== undefined ? `data-id="${opcoes.id}"` : ''} data-delta="${b.delta}" data-min="${opcoes.min}" data-ref="${opcoes.ref ?? 0}">${esc(b.rotulo)}</button>`,
    )
    .join('');
  return `<div class="dinheiro-campo">
    <label class="dinheiro"><span class="rs" aria-hidden="true">R$</span>
      <input type="text" inputmode="numeric" autocomplete="off" value="${formatarNumero(valor)}" ${atributos} aria-label="${esc(opcoes.rotulo ?? 'Valor em reais')}" /></label>
    <div class="dinheiro-ext" data-ext="${chave}">${valor > 0 ? esc(dinheiroExtenso(valor)) : '–'}</div>
    <div class="dinheiro-bt">${botoes}</div></div>`;
}

export function textoExtenso(n: number): string {
  return n > 0 ? dinheiroExtenso(n) : '–';
}
